// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ProductController = function (
    $rootScope,
    $scope,
    $http,
    ProductInfo,
    Component,
    Coupon,
    Discount,
    PlanVariant,
    Plan,
    PlanGroup,
    gettext,
    gettextCatalog,
    PlanOrder,
    $filter,
    ProductOrders,
    babelFilter,
    CustomFieldSettings) {
    var localStorageParamName = 'productUiSettings';
    var settings = [null, null, null, null];
    $scope.showHidden = false;  

    $scope.TabTypes = Object.freeze({
        "Plans": "plans",
        "Components": "components",
        "Discounts": "discounts",
        "Coupons": "coupons"
    });
    $scope.selectedTab = $scope.TabTypes.Plans;

    const DURATION_TYPE = Object.freeze({
        'Unlimited': 'Unlimited',
        'FirstContractPeriod': 'FirstContractPeriod',
        'FixedPeriod': 'FixedPeriod',
    });
    
    $scope.isCustomFieldsSearchShown=function(){
        return $scope.isProductCustomFieldsAvailable 
            &&($scope.selectedTab === $scope.TabTypes.Plans || $scope.selectedTab === $scope.TabTypes.Components);
    };

    CustomFieldSettings.get({ customFieldType: "Product" }, function (data){
        $scope.customFields = data.CustomFieldDescriptors.filter(d => d.IndexType !== "None");
        $scope.isProductCustomFieldsAvailable = $scope.customFields && $scope.customFields.length > 0;
    });

    $scope.toggleDisplayHiddenItems = function() {        
        $scope.showHidden = !$scope.showHidden;
        $scope.loadProductInfoOrTakeFromCache($scope.showHidden);
    };
    
    $scope.search = [];
    $scope.searchComponentTypeInput = '';
    $scope.searchCustomFields=[];
    $scope.noResults = [];
    $scope.durationTypes = DURATION_TYPE;
    $scope.isProductCustomFieldsAvailable = false;

    function setSelectedPriceList(preselectedPriceListId) {
        let unhiddenPriceLists = $scope.productInfo.PriceListsByPlanGroupId($scope.selectedGroup.Id).filter(i => !i.Hidden);
        $scope.selectedPriceList = unhiddenPriceLists.find(p => p.Id === preselectedPriceListId)
            ?? unhiddenPriceLists.find(p => p.Id === $scope.selectedGroup.DefaultPriceListId)
            ?? unhiddenPriceLists[0] ?? $scope.productInfo.PriceListById($scope.selectedGroup.DefaultPriceListId);
    }

    $scope.loadProductInfoOrTakeFromCache = function (showHidden) {
        if ($scope.productInfoCache && $scope.productInfoCache[showHidden])
            $scope.productInfoCallback($scope.productInfoCache[showHidden], showHidden);
        else
            $scope.loadProductInfo(showHidden);
    };

    $scope.loadProductInfo = function(showHidden) {
        ProductInfo.get(function (data) {
            $scope.productInfoCallback(data, showHidden);
        }, showHidden);
    };

    $scope.loadSettings = function() {
        var settingsLoaded = false;
        try {
            settings = JSON.parse(localStorage.getItem(localStorageParamName));
            if (settings)
                settingsLoaded = true;
        } catch (e) {
        }
        if (!settingsLoaded)
            settings = [null, null, null, null];
        
        return settingsLoaded;
    };

    $scope.productInfoCallback = function(data, showHidden) {
        //Restore previous visibility states
        var settingsLoaded = $scope.loadSettings();
            
        $scope.productInfoCache = $scope.productInfoCache || {};
        $scope.productInfoCache[showHidden] = data;
        $scope.productInfo = data;
        
        if($scope.selectedGroup && data.PlanGroups.length > 0){
            // angular js works based on value hash for objects, so we need to find the object in the array
            $scope.selectedGroup = data.PlanGroups.find(g => g.Id === $scope.selectedGroup.Id);
            settings[0] = $scope.selectedGroup.Id;
        }
        
        if (!$scope.selectedGroup && data.PlanGroups.length > 0) {
            var visibleGroups = data.PlanGroups.filter(g => !g.Hidden);
            $scope.selectedGroup = visibleGroups[0];
        }
            
        if ($scope.selectedGroup && $scope.selectedGroup.DefaultPriceListId) {
            settings[0] = $scope.selectedGroup.Id;
            setSelectedPriceList($scope.selectedGroup.DefaultPriceListId);
            settings[3] = $scope.selectedPriceList?.Id;
        }
        if (!settingsLoaded)
            return;

        if (data.PlanGroups) {
            var unhiddenPlanGroups = data.PlanGroups.filter(g => !g.Hidden);
            if (unhiddenPlanGroups.length === 0) return;
            var preselectedGroupId = settings[0];
            var preselectedPriceListId = settings[3];
            if (preselectedGroupId) {
                var found = false;
                for (var j = 0; j < unhiddenPlanGroups.length; j++) {
                    if (preselectedGroupId === unhiddenPlanGroups[j].Id || unhiddenPlanGroups.length === 1) {
                        $scope.selectedGroup = unhiddenPlanGroups[j];
                        setSelectedPriceList(preselectedPriceListId);
                        settings[3] = $scope.selectedPriceList?.Id;
                        found = true;
                        continue;
                    }
                }
                if (!found) {
                    $scope.selectedGroup = unhiddenPlanGroups[0];
                    setSelectedPriceList($scope.selectedGroup.DefaultPriceListId);
                    settings[0] = $scope.selectedGroup.Id;
                    settings[3] = $scope.selectedPriceList.Id;
                }
            }
        }

        if (data.Plans) {
            var preselectedPlanIds = settings[2];
            if (preselectedPlanIds) {
                for (var j = 0; j < data.Plans.length; j++) {
                    if (preselectedPlanIds.indexOf(data.Plans[j].Id) !== -1) {
                        data.Plans[j].show = true;
                    }
                }
            }
        }
        if (!!settings[1])
            $scope.selectedTab = settings[1];
    };

    $scope.loadProductInfo($scope.showHidden);
    function confirm(header, deleteCallback) {
        $scope.yesCancel(header, gettextCatalog.getString(gettext('Are you sure?')), function() { deleteCallback(); });
    }

    $scope.deletePlanVariant = function(planVariant) {
        confirm(gettextCatalog.getString(gettext('Delete Plan Variant')),
            function() {
                PlanVariant.remove({ planVariantId: planVariant.Id }, function() { $scope.loadProductInfo($scope.showHidden); });
            });
    };

    $scope.deleteComponent = function(component) {
        confirm(gettextCatalog.getString(gettext('Delete Component')),
            function() {
                Component.remove({ componentId: component.Id }, function() { $scope.loadProductInfo($scope.showHidden); });
            });
    };
    $scope.deleteDiscount = function(discount) {
        confirm(gettextCatalog.getString(gettext('Delete Discount')),
            function() {
                Discount.remove({ discountId: discount.Id }, function() { $scope.loadProductInfo($scope.showHidden); });
            });
    };
    $scope.deletePlan = function(plan) {
        confirm(gettextCatalog.getString(gettext('Delete Plan')),
            function() {
                Plan.remove({ planId: plan.Id }, function() { $scope.loadProductInfo($scope.showHidden); });
            });
    };

    $scope.deletePlanGroup = function(planGroup) {
        confirm(gettextCatalog.getString(gettext('Delete Plan Group')),
            function() {
                PlanGroup.remove({ planGroupId: planGroup.Id }, function() { $scope.loadProductInfo($scope.showHidden); });
            });
    };
    $scope.deleteCoupon = function(coupon) {
        confirm(gettextCatalog.getString(gettext('Delete Coupon')),
            function() {
                Coupon.remove({ couponId: coupon.Id }, function() { $scope.loadProductInfo($scope.showHidden); });
            });
    };

    $scope.baseSortableOptions = {
        over: function(event, ui) {
            $(ui.item.context).addClass('st-enabled').removeClass('st-disabled');
        },
        out: function(event, ui) {
            $(ui.item.context).addClass('st-disabled').removeClass('st-enabled');
        },
        start: function(event, ui) {
            $(ui.item.context).addClass('st-enabled');
        },
        stop: function(event, ui) {
            $(ui.item.context).removeClass('st-enabled').removeClass('st-disabled');
        },
        axis: 'Y'
    };
    $scope.baseSortableHelper = {
        helper: function(e, ui) {
            ui.children().each(function() {
                $(this).width($(this).width());
            });
            return ui;
        }
    };

    $scope.sortableOptionsForPlan = {
        update: function() {
            createPlanTree();
        }
    }

    $scope.sortableOptionsForVariants = {
        update: function() {
            createPlanTree();
        }
    }

    $scope.sortableOptionsForComponents = {
        update: function(e, ui) {
            createList('Component', 'componentid');
        }
    }
    $scope.sortableOptionsForDiscounts = {
        update: function(e, ui) {
            createList('Discount', 'discountid');
        }
    }
    $scope.sortableOptionsForCoupons = {
        update: function(e, ui) {
            createList('Coupon', 'couponid');
        }
    }

    angular.extend($scope.sortableOptionsForPlan, $scope.baseSortableOptions);
    angular.extend($scope.sortableOptionsForVariants, $scope.baseSortableOptions, $scope.baseSortableHelper);
    angular.extend($scope.sortableOptionsForComponents, $scope.baseSortableOptions, $scope.baseSortableHelper);
    angular.extend($scope.sortableOptionsForDiscounts, $scope.baseSortableOptions, $scope.baseSortableHelper);
    angular.extend($scope.sortableOptionsForCoupons, $scope.baseSortableOptions, $scope.baseSortableHelper);

    if ($rootScope.hasRole('ReadOnlyOperations')) {
        $scope.sortableOptionsForPlan.disabled = true;
        $scope.sortableOptionsForVariants.disabled = true;
        $scope.sortableOptionsForComponents.disabled = true;
        $scope.sortableOptionsForDiscounts.disabled = true;
        $scope.sortableOptionsForCoupons.disabled = true;
    }

    $scope.getPlans = function (id) {
        if($scope.selectedTab !== $scope.TabTypes.Plans && !!$scope.selectedTab)
            return;
        if (!$scope.productInfo) {
            return;
        }
        var result = [];
        if ($scope.productInfo.PlansByPlanGroupId) {
            var _items = $scope.productInfo.PlansByPlanGroupId(id);
            if (_items.length === 0) {
                return result;
            }
            var items = [];
            angular.forEach(_items,
                function(it) {
                    items.push(it);
                });

            var planOrder = $scope.planOrder;
            if (planOrder && angular.isArray(planOrder.PlanOrderItems) && planOrder.PlanOrderItems.length > 0) {
                for (var i = 0; i < planOrder.PlanOrderItems.length; i++) {
                    var it = planOrder.PlanOrderItems[i];
                    for (var j = 0; j < items.length; j++) {
                        if (items[j].Id === it.PlanId) {
                            result.push(items[j]);
                            items.splice(j, 1);
                            break;
                        }
                    }
                }

                if (items.length > 0) {
                    result = result.concat(items);
                }
            } else {
                result = $filter('orderBy')(items, 'Name');
            }
        }
        result = $scope.HideItems($scope.TabTypes.Plans, result);
        const searchValue = $scope.search[$scope.TabTypes.Plans];        
        const searchCustomFields=$scope.searchCustomFields[$scope.TabTypes.Plans];        
        if(!searchValue && !searchCustomFields)
            return result;

        result = $filter('filter')(result, function(plan, index, array){
            if (searchValue) {
                const variants = $scope.productInfo.PlanVariantsByPlanId(plan.Id);
                let foundInVariants = false;
                for (let i = 0; i < variants.length; i++) {
                    if (stringContainsValue(variants[i].InternalName, searchValue) || stringContainsValue(variants[i].ExternalId, searchValue)) {
                        plan.showInSearch = true; // Matched by variant -> we should open the plan to show the variant
                        plan.disableToggle = true;
                        foundInVariants = true;
                        break;
                    }
                }
                if(!foundInVariants && !stringContainsValue(babelFilter(plan.Name), searchValue)){
                    return false;
                }
            }
            if (searchCustomFields && !searchByCustomFields(plan, searchCustomFields)){                
                return false;
            }            
            return true;
        });

        setSearchResult($scope.TabTypes.Plans, result.length);

        return result;
    };

    $scope.getPlanVariants = function(id) {
        var result = [];
        if ($scope.productInfo.PlanVariantsByPlanId) {
            var _items = $scope.productInfo.PlanVariantsByPlanId(id);

            if (_items.length === 0) {
                return result;
            }
            var items = [];
            angular.forEach(_items,
                function(it) {
                    items.push(it);
                });

            var planOrder = null;
            if ($scope.planOrder && angular.isArray($scope.planOrder.PlanOrderItems)) {
                angular.forEach($scope.planOrder.PlanOrderItems,
                    function(it) {
                        if (id === it.PlanId) {
                            planOrder = it;
                        }
                    });
            }
            items = $scope.HideItems($scope.TabTypes.Plans, items);
            var sorted = $filter('orderBy')(items, 'Id');

            if (planOrder && angular.isArray(planOrder.PlanVariantOrder) && planOrder.PlanVariantOrder.length > 0) {
                for (var i = 0; i < planOrder.PlanVariantOrder.length; i++) {
                    var it = planOrder.PlanVariantOrder[i];
                    for (var j = 0; j < items.length; j++) {
                        if (items[j].Id === it) {
                            result.push(items[j]);
                            items.splice(j, 1);
                            break;
                        }
                    }
                }
                for (var j = 0; j < sorted.length; j++) {
                    if (result.indexOf(sorted[j]) === -1)
                        result.push(sorted[j]);
                }
            } else {
                result = sorted;
            }
        }
        return result;
    };

    $scope.updateFilter = function(){
        if(!$scope.selectedTab)
            $scope.selectedTab = $scope.TabTypes.Plans;
        $scope.productInfo.Plans.forEach(plan => {
            plan.showInSearch = false;
            plan.disableToggle = false;
        });
        $scope.search[$scope.selectedTab] = $scope.searchInput;
        $scope.searchComponentType = $scope.searchComponentTypeInput;        
        if($scope.isCustomFieldsSearchShown() && $scope.searchCustomFieldsKey)
            $scope.searchCustomFields[$scope.selectedTab] = {key:$scope.searchCustomFieldsKey, value:$scope.searchCustomFieldsValue};
        else $scope.searchCustomFields[$scope.selectedTab]=null;
    }

    $scope.getComponents = function(id) {
        var components = getProductItems(id, 'ComponentsByPlanGroupId', $scope.componentOrders);
        components = $scope.HideItems($scope.TabTypes.Components, components);
        let result = [];
        const searchValue = $scope.search[$scope.TabTypes.Components];        
        const searchCustomFields=$scope.searchCustomFields[$scope.TabTypes.Components];
        
        for (let i = 0; i < components.length; i++) {
            
            //search
            if ($scope.searchComponentType && components[i].ComponentType!==$scope.searchComponentType) {
                continue;
            }
            if(searchValue && !stringContainsValue(babelFilter(components[i].Name), searchValue)
                && !stringContainsValue(components[i].ExternalId, searchValue)){
                continue;                
            }            
            if (searchCustomFields && !searchByCustomFields(components[i], searchCustomFields)){
                continue;
            }
            //add Price List info
            const item = $scope.getPriceListItem(components[i]);
            Object.assign(components[i], {DiscountScale: null, PriceScale: null, PricePerUnit: null});
            if (item && item.RecurringPrice) {
                Object.assign(components[i], item.RecurringPrice);
            }
            result.push(components[i]);
        }

        setSearchResult($scope.TabTypes.Components, result.length);
        return result; 
    };

    $scope.getDiscounts = function(id) {
        var items = getProductItems(id, 'DiscountsByPlanGroupId', $scope.discountOrders);
        items = $scope.HideItems($scope.TabTypes.Discounts, items);
        items = filterDataByFields(items, $scope.search[$scope.TabTypes.Discounts], function(obj){return [obj.InternalName];});
        setSearchResult($scope.TabTypes.Discounts, items.length);
        return items;
    };

    $scope.getCoupons = function(id) {
        var items =  getProductItems(id, 'CouponsByPlanGroupId', $scope.couponOrders);
        items = $scope.HideItems($scope.TabTypes.Coupons, items);
        items = filterDataByFields(items, $scope.search[$scope.TabTypes.Coupons], function(obj){return [obj.InternalName];});
        setSearchResult($scope.TabTypes.Coupons, items.length);
        return items;
    };

    $scope.GetSelfServiceLink = function (planVariantId) {
        var priceListIdPostfix = $scope.selectedPriceList.Id === $scope.selectedGroup.DefaultPriceListId ? '' : '?priceListId=' + $scope.selectedPriceList.Id;
        return $scope.productInfo.SelfServiceUrl + 'portal/signup.html#/' + planVariantId + priceListIdPostfix;
    }

    function searchByCustomFields(dataItem, customFieldSearch){
        if (customFieldSearch.value) {
            return !!(dataItem.CustomFields && dataItem.CustomFields[customFieldSearch.key]
                && dataItem.CustomFields[customFieldSearch.key] === customFieldSearch.value);
        }
        return !!(dataItem.CustomFields && !dataItem.CustomFields[customFieldSearch.key]);
    }
    
    function filterDataByFields(data, searchValue, getValuesToSearchIn){
        if(!searchValue)
            return data;

        return $filter('filter')(data, function(dataItem, index, array){      
            const searchInValues = getValuesToSearchIn(dataItem);
            for (let i = 0; i < searchInValues.length; i++) {
                if(stringContainsValue(searchInValues[i], searchValue))
                    return true;
            }
            return false;
        });
    }

    function stringContainsValue(string, value){
        if(!string)
            return false;
        return string.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    }

    function setSearchResult(tab, dataCount){
        $scope.noResults[tab] = dataCount === 0;
    }

    $scope.shouldShowPlan = function(plan){
        return wasSearchingByText() || wasSearchingByCustomField() ? plan.showInSearch : plan.show;
    }

    $scope.noPlanVariants = function (plan) {
        return $scope.productInfo.PlanVariantsByPlanId(plan.Id).filter(p => !p.Hidden || $scope.showHidden).length == 0 && $scope.shouldShowPlan(plan);
    }

    function wasSearchingByText(){
        return !!$scope.search[$scope.selectedTab];
    }

    function wasSearchingByCustomField(){
        return !!$scope.searchCustomFields[$scope.selectedTab];
    }    
    
    $scope.showNoResultsInfobox = function(){
        var searching = wasSearchingByText() || wasSearchingByCustomField() || ($scope.selectedTab === $scope.TabTypes.Components && $scope.searchComponentType);
        return searching && $scope.noResults[$scope.selectedTab];
    }

    function getProductItems(id, getter, order) {
        var result = [];
        if ($scope.productInfo && $scope.productInfo[getter]) {
            var _items = $scope.productInfo[getter](id);
            if (_items.length === 0) {
                return result;
            }
            var items = [];
            angular.forEach(_items,
                function(it) {
                    items.push(it);
                });
            result = orderItems(items, order)
        }
        return result;
    }

    function orderItems(items, productOrders) {
        var result = [];
        if (productOrders &&
            angular.isArray(productOrders.ProductOrderItems) &&
            productOrders.ProductOrderItems.length > 0) {
            var products = productOrders.ProductOrderItems;
            for (var i = 0; i < products.length; i++) {
                var it = products[i];
                for (var j = 0; j < items.length; j++) {
                    if (items[j].Id === it) {
                        result.push(items[j]);
                        items.splice(j, 1);
                        break;
                    }
                }
            }
            if (items.length > 0) {
                result = result.concat(items);
            }
        } else {
            result = $filter('orderBy')(items, 'Id');
        }
        return result;
    }

    $scope.$watch("selectedGroup.Id",
        function() {
            loadOrders();
        });

    function loadOrders() {
        if ($scope.selectedGroup && $scope.selectedGroup.Id) {
            var id = $scope.selectedGroup.Id;

            $scope.planOrder = PlanOrder.get({ planGroupId: id }, function() {});

            // can be move in 1 query
            $scope.componentOrders = ProductOrders.get({ planGroupId: id, productOrderType: 'Component' },
                function() {});
            $scope.discountOrders = ProductOrders.get({ planGroupId: id, productOrderType: 'Discount' }, function() {});
            $scope.couponOrders = ProductOrders.get({ planGroupId: id, productOrderType: 'Coupon' }, function() {});
        }
    }

    function createPlanTree() {
        var planOrder = new PlanOrder();

        if ($scope.planOrder && $scope.planOrder.Id) {
            planOrder.Id = $scope.planOrder.Id;
        }

        planOrder.PlanGroupId = $scope.selectedGroup.Id;
        planOrder.PlanOrderItems = [];

        $('div[planid]').each(function() {
            var id = $(this).attr('planid');
            var item = { PlanId: id, PlanVariantOrder: [] };
            planOrder.PlanOrderItems.push(item);

            $('[plancontainer=\'' + id + '\'] [planvariantid]').each(function() {
                var id = $(this).attr('planvariantid').trim();
                item.PlanVariantOrder.push(id);
            });
        });

        if (planOrder.Id) {
            planOrder.$update({ id: planOrder.Id },
                function(data) {
                    $scope.planOrder = data;
                });
        } else {
            planOrder.$save({ planGroupId: planOrder.PlanGroupId },
                function(data) {
                    $scope.planOrder = data;
                });
        }
    }

    function createList(type, id) {
        var productOrders = new ProductOrders();

        if ($scope.productOrders && $scope.productOrders.Id) {
            productOrders.Id = $scope.productOrders.Id;
        }

        productOrders.PlanGroupId = $scope.selectedGroup.Id;
        productOrders.ProductOrderType = type;
        productOrders.ProductOrderItems = [];

        $('tr[' + id + ']').each(function() {
            var pid = $(this).attr(id);
            productOrders.ProductOrderItems.push(pid);
        });

        productOrders.$save({},
            function(data) {
                $scope.productOrders = data;
            });
    }

    $scope.getDiscountName = function(id) {
        var discounts = $scope.productInfo.Discounts;
        for (var i = 0; i < discounts.length; i++) {
            if (id === discounts[i].Id) {
                return discounts[i].InternalName;
            }
        }
    };

    $scope.setActiveGroup = function() {
        settings[0] = null;
        settings[3] = null;
        if ($scope.selectedGroup) {
            settings[0] = $scope.selectedGroup.Id;
            setSelectedPriceList($scope.selectedGroup.DefaultPriceListId);
            if ($scope.selectedPriceList)
                settings[3] = $scope.selectedPriceList.Id;
        }
        localStorage.setItem(localStorageParamName, JSON.stringify(settings));
    };

    $scope.setActivePriceList = function() {
        settings[3] = $scope.selectedPriceList ? $scope.selectedPriceList.Id : null;
        localStorage.setItem(localStorageParamName, JSON.stringify(settings));
    };

    $scope.HideItems = function (tabType, items){
        if(!$scope.showHidden){
            return $filter('filter')(items, {'Hidden': false});
        }
        return items;
    }

    function changeItemVisibility(id, hide, item) {
        let method = "PATCH";
        let route = `/api/v1/${item}/${id}`;
        let data = { "Id": id, "Hidden": hide };

        if (item === "plangroups") {
            method = "POST";
            route += "/visibility";
        }

        $http({
            method: method,
            url: route,
            data: data,
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(function() {
            $scope.loadProductInfo($scope.showHidden);
        });
    }

    $scope.hideItem = function(id, item, $event, itemName) {
        $scope.yesCancel(_txt(gettext('You are about to hide an item.')),
            _txt(gettext('Are you sure?')),
            function() {
                changeItemVisibility(id, true, item);
            });
        $event.stopPropagation();
    };

    $scope.unhideItem = function(id, item, $event, itemName) {
        $scope.yesCancel(_txt(gettext('You are about to make an item visible again.')),
            _txt(gettext('Are you sure?')),
            function() {
                changeItemVisibility(id, false, item);
            });
        $event.stopPropagation();
    };

    function _txt(msg) {
        return gettextCatalog.getString(msg);
    }

    $scope.togglePlanVisibility = function(plan) {
         if(plan.disableToggle)
            return;
        if(wasSearchingByText() || wasSearchingByCustomField()){
            plan.showInSearch = !plan.showInSearch;
            return; // Don't save changes from search mode.
        }

        plan.show = !plan.show;
        if (!settings[2]) {
            settings[2] = [];
        }

        if (plan.show) {
            settings[2].push(plan.Id);
        } else {
            var index = settings[2].indexOf(plan.Id);
            if (index !== -1) {
                settings[2].splice(index, 1);
            }
        }

        localStorage.setItem(localStorageParamName, JSON.stringify(settings));
    };

    $scope.setActiveTab = function(selTab) {
        $scope.selectedTab = selTab;
        settings[1] = selTab;
        localStorage.setItem(localStorageParamName, JSON.stringify(settings));
        $scope.searchInput = $scope.search[selTab];
        $scope.searchCustomFieldsKey = $scope.searchCustomFields[selTab]? $scope.searchCustomFields[selTab].key: null;
        $scope.searchCustomFieldsValue = $scope.searchCustomFields[selTab]? $scope.searchCustomFields[selTab].value: null;
    }

    $scope.clonePlan = function (planId, $event) {
        $scope.yesCancel(_txt(gettext("You are about to duplicate a plan including plan variants.")),
            _txt(gettext("Please note: External ID of plan variants will be emptied while cloning! Are you sure?")),
            function () {
                postClonePlan(planId);
            });
        $event.stopPropagation();
    }

    $scope.getPriceListItem = function (product) {
        return $scope.selectedPriceList ? ($scope.selectedPriceList.Items.find(x => x.ProductId === product.Id) || $scope.selectedPriceList.ParentItems?.find(x => x.ProductId === product.Id)) : null;
    }

    $scope.isPriceDefined = function (product) {
        var priceListItem = $scope.getPriceListItem(product);
        return priceListItem != null && (priceListItem.OneOffPrice != null || priceListItem.RecurringPrice != null);
    }

    $scope.cloneComponent = function(componentId, $event) {
        $scope.yesCancel(_txt(gettext("You are about to duplicate a component.")),
            _txt(gettext("Please note: External ID of components will be emptied while cloning! Are you sure?")),
            function() {
                postCloneComponent(componentId);
            });
        $event.stopPropagation();
    }

    function postClonePlan(planId) {
        $http({
            method: "POST",
            url: "/api/v1/plans/" + planId + "/clone",
            //data: { "Id": id, "Hidden": hide },
            headers: {"Content-Type": "application/json"},
            cache: false
        }).then(function (response) {
            window.location.href = "#/plans/" + response.data.Id + "/edit";
        });
    }

    function postCloneComponent(componentId) {
        $http({
            method: "POST",
            url: "/api/v1/components/" + componentId + "/clone",
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(function (response) {
            window.location.href = "#/components/" + response.data.Id;
        });
    }
};


ProductController.$inject = [
    '$rootScope', '$scope', '$http', 'ProductInfo', 'Component', 'Coupon', 'Discount', 'PlanVariant', 'Plan',
    'PlanGroup', 'gettext', 'gettextCatalog', 'PlanOrder', '$filter', 'ProductOrders', 'babelFilter',
    'CustomFieldSettings'
];
